<template>
  <div class="container container-table">
      <div class="row vertical-10p vertical-center">
        <div class="container">
          <img src="static/img/logo.png" class="center-block logo">
          <div class="text-center col-sm-6 col-sm-offset-3 style-404">
            <br>
            <h1>404</h1>
            <h1>Página no encontrada.</h1><br>
            <h4>Lo sentimos, la página que buscas no existe o no se encuentra en nuestro servidor.</h4>              
            <router-link to="/" class="home-link">Volver al inicio. <i class="fa fa-home" aria-hidden="true"></i></router-link>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'NotFound'
  }
</script>

<style>
.vertical-center {
  display: flex;
  align-items: center;
  min-height: 80vh;
}

.home-link {
  font-size: 1.5em;   
}

@media (max-width: 767px) {
    .style-404 {
        margin-right: -140px;
    }
}

</style>



// WEBPACK FOOTER //
// 404.vue?101da323